import React, { useState } from "react";
import { addDocumentFirebase } from "../../../../services/data-firebase";
import { useUser } from "../../../../context/UserContext";
import { motion } from "framer-motion";
import { FaArrowLeft, FaChild, FaMoneyBillWave, FaCalendarAlt, FaClock, FaCheckCircle } from "react-icons/fa";

export default function ContractForm({ nana, onBack ,handleRefresh}) {
  const { user } = useUser(); // Accede a los datos del usuario desde el contexto

  const [formData, setFormData] = useState({
    detallesNinos: "",
    tipoPago: "",
    tipoContratacion: "",
    diasServicio: [],
    tipoHorario: "",
    propuestaEconomica: "",
    state: false,
    idPadre: user.idFirestore,
    idNana: nana.idFirestore,
    padres: user,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let propuestaEconomica = { nana, ...formData };
    let nambreCollectionForMatchWithcSub = "match-subs";
   // console.log("Propuesta Economica :", propuestaEconomica);
    try {
      addDocumentFirebase(nambreCollectionForMatchWithcSub, propuestaEconomica);
      onBack();
      handleRefresh();
    } catch (error) {
      alert("Formulario enviado correctamente");
      console.error(error, "Error al crear match por sub");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg"
    >
      {/* Botón para volver a los detalles de la niñera */}
      <button
        onClick={onBack}
        className="flex items-center text-blue-500 hover:text-blue-700 mb-4"
      >
        <FaArrowLeft className="mr-2" />
        Volver a los detalles
      </button>

      {/* Formulario de contratación */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaChild className="inline-block mr-2" />
            Detalles de los niños
          </label>
          <textarea
            name="detallesNinos"
            value={formData.detallesNinos}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            required
          />
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaMoneyBillWave className="inline-block mr-2" />
            Tipo de Pago
          </label>
          <select
            name="tipoPago"
            value={formData.tipoPago}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            required
          >
            <option value="">Seleccionar</option>
            <option value="blanco">Blanco</option>
            <option value="negro">Negro</option>
            <option value="monotributista">Monotributista</option>
          </select>
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaCalendarAlt className="inline-block mr-2" />
            Tipo de Contratación
          </label>
          <select
            name="tipoContratacion"
            value={formData.tipoContratacion}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            required
          >
            <option value="">Seleccionar</option>
            <option value="hora">Por Hora</option>
            <option value="mes">Por Mes</option>
          </select>
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaCalendarAlt className="inline-block mr-2" />
            Días del Servicio
          </label>
          <div className="grid grid-cols-2 gap-2">
            {["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"].map((dia) => (
              <label key={dia} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="diasServicio"
                  value={dia}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    setFormData((prev) => ({
                      ...prev,
                      diasServicio: checked
                        ? [...prev.diasServicio, value]
                        : prev.diasServicio.filter((d) => d !== value),
                    }));
                  }}
                  className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                />
                <span>{dia}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaClock className="inline-block mr-2" />
            Tipo de Horario
          </label>
          <select
            name="tipoHorario"
            value={formData.tipoHorario}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            required
          >
            <option value="">Seleccionar</option>
            <option value="mañana">Mañana</option>
            <option value="tarde">Tarde</option>
            <option value="noche">Noche</option>
          </select>
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-2">
            <FaMoneyBillWave className="inline-block mr-2" />
            Propuesta Económica
          </label>
          <input
            type="text"
            name="propuestaEconomica"
            value={formData.propuestaEconomica}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            required
          />
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          type="submit"
          className="w-full bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition-all flex items-center justify-center"
        >
          <FaCheckCircle className="mr-2" />
          Enviar Propuesta
        </motion.button>
      </form>
    </motion.div>
  );
}